// src/pages/HostelDetail.jsx
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import useApi from '../hooks/useApi';

export default function HostelDetail() {
    const { id } = useParams(); // id === accommodation UID
    const navigate = useNavigate();
    const { request } = useApi();

    const [hostel, setHostel] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [odaUyarisi, setOdaUyarisi] = useState(false);

    useEffect(() => {
        const fetchDetail = async () => {
            try {
                const res = await request(`/accommodations/${id}`);
                setHostel(res.data);

                const imageRes = await request(`/contents/accommodation/${id}`);
                if (Array.isArray(imageRes.data) && imageRes.data.length > 0) {
                    setImageUrl(imageRes.data[0].contentUrl);
                }
            } catch (err) {
                console.error("Detay verisi alınamadı:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchDetail();
    }, [id]);

    const handleReservationClick = () => {
        const isAuth = localStorage.getItem('auth') === 'true';

        if (!isAuth) {
            navigate('/login');
        } else {
            if (!selectedUnit) {
                setOdaUyarisi(true);
                return;
            }
            setOdaUyarisi(false);
            navigate(`/reservation/${selectedUnit}`);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-100">
                <p className="text-gray-600">Yükleniyor...</p>
            </div>
        );
    }

    if (!hostel) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-100">
                <p className="text-red-500">Pansiyon bulunamadı.</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Hero Görsel */}
            <div className="relative">
                <img
                    src={imageUrl || "https://via.placeholder.com/800x400?text=Görsel+Bulunamadı"}
                    alt={hostel.name}
                    className="w-full h-64 object-cover md:h-96"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                    <div className="text-center">
                        <h1 className="text-3xl md:text-5xl text-white font-bold mb-2">{hostel.name}</h1>
                        <p className="text-white text-sm md:text-lg">
                            {hostel.city?.name} / {hostel.town?.name} / {hostel.village?.name || 'Köy yok'}
                        </p>
                    </div>
                </div>
            </div>

            <div className="container mx-auto p-6 md:p-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
                {/* Açıklama ve İçerik */}
                <div className="lg:col-span-2 space-y-6">
                    <section className="bg-white p-6 rounded-lg shadow-md">
                        <h2 className="text-2xl font-semibold mb-4">Açıklama</h2>
                        <p className="text-gray-700 leading-relaxed">{hostel.description}</p>
                    </section>

                    {hostel.units?.length > 0 && (
                        <section className="bg-white p-6 rounded-lg shadow-md">
                            <div className="flex items-center justify-between">
                                <h2 className="text-2xl font-semibold mb-4">Odalar</h2>
                                {odaUyarisi && (
                                    <span className="text-red-600 text-sm ml-4">Lütfen bir oda seçiniz</span>
                                )}
                            </div>
                            <ul className="space-y-3">
                                {hostel.units.map((unit) => (
                                    <li
                                        key={unit.uid}
                                        onClick={() => {
                                            setSelectedUnit(unit.uid);
                                            setOdaUyarisi(false);
                                        }}
                                        className={`cursor-pointer text-gray-800 border p-3 rounded-md ${selectedUnit === unit.uid
                                            ? 'bg-green-100 border-green-400'
                                            : 'bg-gray-50 hover:bg-gray-100'
                                            }`}
                                    >
                                        <strong>{unit.name}</strong> – {unit.description}
                                    </li>
                                ))}
                            </ul>
                        </section>
                    )}

                    {hostel.comments?.length > 0 && (
                        <section className="bg-white p-6 rounded-lg shadow-md">
                            <h2 className="text-2xl font-semibold mb-4">Yorumlar</h2>
                            <ul className="space-y-4">
                                {hostel.comments.map((comment) => (
                                    <li key={comment.uid} className="border-l-4 pl-4 border-green-500 text-gray-700">
                                        <p className="italic">"{comment.commentBody}"</p>
                                        <p className="text-sm mt-1 text-gray-500">
                                            – {comment.user?.name} {comment.user?.surname}
                                        </p>
                                    </li>
                                ))}
                            </ul>
                        </section>
                    )}
                </div>

                {/* Sağ Panel */}
                <aside className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center">
                    <button
                        onClick={handleReservationClick}
                        className="w-full py-3 bg-[#7F6B52] text-white font-semibold rounded-lg shadow hover:brightness-110 transition-colors mb-4"
                    >
                        Rezervasyon Yap
                    </button>
                    <p className="text-sm text-gray-500 text-center">
                        Ücretsiz iptal ve değişiklik hakkı.
                    </p>
                    <Link to="/search" className="mt-4 text-[#7F6B52] hover:underline">
                        Geri Dön
                    </Link>
                </aside>
            </div>
        </div>
    );
}
